export async function fetchDashboardSummary(token, { isSilent = false } = {}) {
  if (!token || isSilent) {
    return { summary: null, categories: [], recentActivity: [] };
  }

  try {
    const res = await fetch("https://api.kloudscan.com/dashboard-summary", {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      cache: "no-store",
    });

    if (res.status === 401 || res.status === 403) {
      console.warn("[fetchDashboardSummary] Unauthorized or expired token");
      throw new Error("unauthorized");
    }

    if (res.status === 404) {
      return { summary: null, categories: [], recentActivity: [] };
    }

    if (!res.ok) {
      const text = await res.text().catch(() => "");
      throw new Error(
        `dashboard-summary ${res.status}: ${text || res.statusText}`,
      );
    }

    const json = JSON.parse((await res.text()) || "{}");

    return {
      summary: json?.summary ?? null,
      categories: Array.isArray(json?.categories) ? json.categories : [],
      recentActivity: Array.isArray(json?.recentActivity)
        ? json.recentActivity
        : [],
    };
  } catch (err) {
    if (err.message !== "unauthorized") {
      console.warn("[fetchDashboardSummary] failed:", err.message);
    }
    return { summary: null, categories: [], recentActivity: [] };
  }
}
